__turbopack_context__.v({
  "button": "video-banner-module-scss-module__ferP3G__button",
  "copy": "video-banner-module-scss-module__ferP3G__copy",
  "hasCopy": "video-banner-module-scss-module__ferP3G__hasCopy",
  "image": "video-banner-module-scss-module__ferP3G__image",
  "picture": "video-banner-module-scss-module__ferP3G__picture",
  "playPauseButton": "video-banner-module-scss-module__ferP3G__playPauseButton",
  "title": "video-banner-module-scss-module__ferP3G__title",
  "videoBanner": "video-banner-module-scss-module__ferP3G__videoBanner",
  "vimeoContainer": "video-banner-module-scss-module__ferP3G__vimeoContainer",
  "visible": "video-banner-module-scss-module__ferP3G__visible",
});
